import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { images, pricing } from '../data/content';
const reassurance = ['Payment is one-time · no subscription', 'Instant access to all 11 PDF files', '7-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="relative isolate overflow-hidden border-b border-line" data-id="element-87" data-mp="15fgj2o0dj92i">
      <img src={images.pitch} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" data-id="element-88" data-mp="1jbk8m40ayt8n" />
      <div className="absolute inset-0 bg-night/85" aria-hidden="true" data-id="element-89" data-mp="1t37t1kyfza0m" />

      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 sm:py-24" data-id="element-90" data-mp="1o3v6707km2y1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-91" data-mp="1o67pphsz8ld7">
          Final countdown
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-92" data-mp="1x51q7j9fhvw1">
          Complete package, launch price
        </h2>

        <div className="mt-8" data-id="element-93" data-mp="s4petwmf2sel">
          <Countdown size="md" data-id="element-94" data-mp="s3w5cnw2posr" />
        </div>

        <p className="mt-10 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-95" data-mp="s6s248w6q7fm">
          6 manuals + 5 bonuses
        </p>
        <div className="mt-3 flex items-baseline justify-center gap-4" data-id="element-96" data-mp="123emkwklmwh4">
          <span className="font-display text-7xl font-extrabold leading-none text-acid" data-id="element-97" data-mp="164gmlfmcbck5">
            {pricing.price}
          </span>
          <span className="font-display text-3xl font-bold text-white/35 line-through" data-id="element-98" data-mp="1b2rydvw73x50">
            {pricing.compare}
          </span>
        </div>
        <p className="mt-3 text-sm font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-99" data-mp="1fwcutji54j23">
          You save {pricing.savings} today
        </p>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-100" data-mp="1pt8xh8lcyayq">
          <CtaButton full label="Yes, I want it now" data-id="element-101" data-mp="1pqczxldf9oat" />
        </div>

        <ul className="mx-auto mt-8 flex max-w-xl flex-col items-center gap-2" data-id="element-102" data-mp="1tuuhddwb7pif">
          {reassurance.map(item => <li key={item} className="flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-white/45" data-id="element-103" data-mp="3qsku2et1hypn">
              <CheckIcon className="h-4 w-4 text-acid" aria-hidden="true" data-id="element-104" data-mp="3huvkv13klib" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}